import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/common/ScrollToTop';
import ErrorBoundary from './components/common/ErrorBoundary';
import InstallPrompt from './components/common/InstallPrompt';

// Accessibility
import AccessibilityWidget from './components/accessibility/AccessibilityWidget';
import './components/accessibility/accessibility.css';

// Hooks
import { usePodium } from './hooks/usePodium';

// Page Components
import Home from './pages/Home';
import PatientPortal from './pages/PatientPortal';
import AboutFacility from './pages/AboutFacility';
import Specialties from './pages/Specialties';
import AboutTeam from './pages/AboutTeam';
import Surgeons from './pages/Surgeons';
import Contact from './pages/Contact';
import Sponsors from './pages/Sponsors';
import PriceTransparency from './pages/PriceTransparency';

// Specialty Pages
import Orthopedics from './pages/specialties/Orthopedics';
import Cardiovascular from './pages/specialties/Cardiovascular';
import PainManagement from './pages/specialties/PainManagement';
import Spine from './pages/specialties/Spine';

// Legal Pages
import DataProcessingAddendum from './pages/legal/DataProcessingAddendum';
import HipaaBaa from './pages/legal/HipaaBaa';
import AccessibilityStatement from './pages/legal/AccessibilityStatement';

const BoardRedirect = () => {
  const { hash } = useLocation();
  return <Navigate to={`/about-team${hash || '#board'}`} replace />;
};

function App() {
  // Load Podium chat widget on all pages
  usePodium();

  return (
    <ErrorBoundary>
      <Flex direction="column" minH="100vh">
      <ScrollToTop />
      <Header />
      
      {/* PWA Install Prompt */}
      <InstallPrompt />
      
      {/* Accessibility Widget */}
      <AccessibilityWidget />
      
      <Box as="main" flex="1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/patient-portal" element={<PatientPortal />} />
          <Route path="/price-transparency" element={<PriceTransparency />} />
          <Route path="/about-facility" element={<AboutFacility />} />
          <Route path="/specialties" element={<Specialties />} />
          <Route path="/specialties/orthopedics" element={<Orthopedics />} />
          <Route path="/specialties/cardiovascular" element={<Cardiovascular />} />
          <Route path="/specialties/pain-management" element={<PainManagement />} />
          <Route path="/specialties/spine" element={<Spine />} />
          <Route path="/about-team" element={<AboutTeam />} />
          {/* The board now lives on the team page. Old links, including deep
              links to one member's profile (/board#vijay-sudheendra), land on
              the same section or profile there. */}
          <Route path="/board" element={<BoardRedirect />} />
          <Route path="/surgeons" element={<Surgeons />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/sponsors" element={<Sponsors />} />
          
          {/* Legal Pages */}
          <Route path="/legal/data-processing-addendum" element={<DataProcessingAddendum />} />
          <Route path="/legal/hipaa-baa" element={<HipaaBaa />} />
          <Route path="/legal/accessibility-statement" element={<AccessibilityStatement />} />
        </Routes>
      </Box>

      <Footer />
    </Flex>
    </ErrorBoundary>
  );
}

export default App;
